import Button from "../../button/Button";
import { CustomPinInput } from "../../input/CustomPinInput";
import { Card } from "../../Card";
import { Arrow } from "../../svg/Wallet/Wallet";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AppLayout } from "../../../layout/AppLayout";
import { useSecurity } from "../../../api/settings/security";
import { Loader } from "../../loader/Loader";

const ChangeTransactionPin = () => {
  const navigate = useNavigate();
  const { handleChangePin, setOldPin, oldPin, pin, setPin, loading } =
    useSecurity();

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">
              Change transaction pin
            </p>
          </div>

          <Card>
            <div className="mb-4">
              <p className="text-sm text-primary-black mb-3.5 font-normal">
                Old pin
              </p>
              <CustomPinInput pin={oldPin} onPinChange={setOldPin} autoFocus />
            </div>
            <div className="mb-4">
              <p className="text-sm text-primary-black mb-3.5 font-normal">
                New pin
              </p>
              <CustomPinInput pin={pin} onPinChange={setPin} />
            </div>
            {/* <div>
              <p className="text-sm text-primary-black mb-3.5 font-normal">
                Confirm pin
              </p>
              <CustomPinInput
                pin={confirmPin}
                onPinChange={setConfrimPin}
                autoFocus={true}
              />
            </div> */}
          </Card>
          <Button
            onClick={handleChangePin}
            text={loading ? <Loader type="bubbles" /> : "Confrim"}
            className={loading && "!py-0"}
          />
        </motion.div>
      </div>
    </AppLayout>
  );
};

export default ChangeTransactionPin;
